import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Header({ title, subtitle, background_img }) {
  
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div 
      className='header p-0 d-flex flex-column justify-content-center align-items-center'
      style={{
        backgroundImage: `url(${background_img})`,
        backgroundClip: 'border-box',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundOrigin: 'border-box',
        backgroundBlendMode: 'multiply',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        height: '70vh',
        width: '100%',
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
        opacity: 0.9,
        color: '#fff',
        textShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
        textAlign: 'center',
      }}
    >
      <div className='header__content d-flex flex-column justify-content-center align-items-center'>
        <h1 
          className='header__content--title text-white display-4 mb-3' 
          data-aos="fade-down"
        >
          {title}
        </h1>
        <p 
          className='header__content--subtitle text-white lead mt-2' 
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {subtitle}
        </p>
      </div>
    </div>
  );
}

export default Header;
